import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-accept-invitation-dialog',
  templateUrl: './accept-invitation-dialog.component.html',
  styleUrls: ['./accept-invitation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcceptInvitationDialogComponent {
  constructor(private dialogRef: MatDialogRef<AcceptInvitationDialogComponent>) {}

  onAccept(): void {
    this.dialogRef.close({ confirm: true });
  }

  onClose(): void {
    this.dialogRef.close({ confirm: false });
  }
}
